const navbar = {
  node: null,
  toggleNode: null,
  animateNodes: null,
  dropdownToggleNodes: null,
  css: {
    open: 'is-open',
    animate: 'navbar-animate--run',
  },

  init() {
    this.node = document.querySelector('.js-navbar');

    if (this.node) {
      this.initDOM();
    }
  },

  initDOM() {
    this.toggleNode = this.node.querySelector('.js-navbar-toggle');
    this.dropdownToggleNodes = Array.from(this.node.querySelectorAll('.js-navbar-dropdown-toggle'));
    this.animateNodes = Array.from(this.node.querySelectorAll('.navbar-animate'));

    if (this.toggleNode) {
      this.toggleNode.addEventListener('click', () => this.handleToggle(), false);
    }

    if (this.dropdownToggleNodes) {
      this.dropdownToggleNodes.forEach((el) => {
        el.addEventListener('click', (e) => this.handleDropdownToggle(e), false);
      });
    }

    this.animateInit();
  },

  handleToggle() {
    const isOpen = this.node.classList.contains(this.css.open);

    this.node.classList[isOpen ? 'remove' : 'add'](this.css.open);
    this.animateToggle(!isOpen);

    if (isOpen) {
      this.closeAllDropwdowns();
    }
  },

  handleDropdownToggle(e) {
      const parent = e.target.parentNode;

      parent.classList.toggle(this.css.open);
  },

  closeAllDropwdowns() {
    if (this.dropdownToggleNodes) {
      this.dropdownToggleNodes.forEach((el) => {
        const parent = el.parentNode;

        parent.classList.remove(this.css.open);
      });
    }
  },

  animateInit() {
    if (this.animateNodes) {
      this.animateNodes.forEach((el, index) => {
        el.style.animationDelay = `${index * 0.05}s`;
      });
    }
  },

  animateToggle(run) {
    if (this.animateNodes) {
      this.animateNodes.forEach((el) => {
        el.classList[run ? 'add' : 'remove'](this.css.animate);
      });
    }
  },
};

export default navbar;



// WEBPACK FOOTER //
// ./scripts/modules/navbar.js